/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { CamelCase, PriceHandler } from '../../../../redux/helper/CamelCase';

export default function TradeSummary({ OrderDetails }) {
    return (
        <div className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
            <div className="border-b border-[#CBCBCB] pb-2.5 flex justify-between items-start">
                <div className="">
                    <p className="text-sm font-semibold text-[#090406]">Order Type</p>
                    <p className="sm:text-lg text-base font-normal text-[#555259]" data-testid="order-type">Trade Order</p>
                </div>
                <p className="text-xs3 font-normal text-[#555259] " style={{ maxWidth: '500px', flexWrap: 'wrap' }}>
                    Total Order Qty.:
                    {Object.keys(OrderDetails?.summary?.quantity).length > 0 && Object.keys(OrderDetails?.summary?.quantity).map((UOM, i) => (
                        <span style={{ float: `${i === 0 ? '' : 'right'}` }} key={UOM} className="font-semibold">
                            {Number(OrderDetails?.summary?.quantity[UOM])}
                            {' '}
                            {UOM}
                            {' '}
                            <br />
                        </span>
                    ))}

                </p>
            </div>
            <div className="pt-1.5">
                <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane active fade show" id="pills-home" role="tabpanel" aria-labelledby="pills-propose-tab">
                        <div className="py-1 border-b border-[#CBCBCB] sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                    {PriceHandler(OrderDetails?.summary?.order_value)}
                                </p>
                            </div>
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Discount</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">{PriceHandler(OrderDetails?.summary?.total_discount)}</p>
                            </div>
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">DAP</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                    {PriceHandler(OrderDetails?.summary?.dap_charges)}
                                </p>
                            </div>
                        </div>
                        <div className="sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Net Amount</p>
                                <p className="sm:text-xs7 text-base font-semibold text-[#000000]">{PriceHandler(OrderDetails?.summary.order_net_amount)}</p>
                            </div>
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-sm text-[#555259] font-normal">Ador Cash redeemed </p>
                                <p className="sm:text-base font-semibold text-[#000000]">{PriceHandler(OrderDetails?.ador_cash_used)}</p>
                            </div>
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Net Value</p>
                                <p className="sm:text-xs7 text-base font-semibold text-[#000000]">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails.summary.ador_cash_order_net_amount : OrderDetails.summary.order_net_amount)}</p>
                            </div>
                        </div>
                        <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">GST (18%)*</p>
                                <p className="sm:text-xs18 text-base font-semibold text-[#555259]">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails.summary.order_gst.ador_cash_avail_gst : OrderDetails.summary.order_gst.gst)}</p>
                            </div>
                        </div>
                        <div className="sm:pr-1 sm:pl-2 py-1">
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-lg text-sm text-[#000000] font-normal">Gross Amount</p>
                                <p className="sm:text-lg text-base font-semibold text-[#000000]" data-testid="total-amount">{PriceHandler(Number(OrderDetails?.ador_cash_used) > 0 ? OrderDetails.summary.ador_cash_order_gross_amount : OrderDetails.summary.order_gross_amount)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
